import React, { useContext } from 'react';
import { DialogBox, Loader } from '@mummssoftware/common-ui';
import { Report } from '@mummssoftware/report';
import { SET_OPEN_REPORT } from '../Context/constants';
import { ReportsContext } from '../Context/ReportsWidgetContext';
import { Context } from '../../context';

export const ReportModal = React.memo(() => {
  const { showLoader, reportOpen, dispatch } = useContext(ReportsContext);
  const { reporting, agency } = useContext(Context);
  return (
    <>
      <DialogBox
        open={!!reportOpen}
        handleClick={() => dispatch({ type: SET_OPEN_REPORT, payload: null })}
        fullWidth
        disableScrollLock
        maxWidth="lg"
        title={reportOpen?.name || ''}
      >
        <div style={{ minHeight: '30vh' }}>
          {showLoader && <Loader />}
          {reportOpen && (
            <Report
              reportHeader={reportOpen}
              reporting={reporting}
              agency={agency}
            />
          )}
        </div>
      </DialogBox>
    </>
  );
});
